import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Button } from "../ui/Button";
import { Input } from "../ui/Input";
import { Label } from "../ui/Label";
import {
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from "../ui/Card";
// import { getFirestore, doc, setDoc, serverTimestamp } from "firebase/firestore"; // Firebase removed
// import { useAuth, db } from "app/auth"; // Firebase removed

export default function RegisterPage() {
    // const { register } = useAuth(); // Firebase removed
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password !== confirmPassword) {
      setError("Les mots de passe ne correspondent pas.");
      return;
    }
    setError(null);
    setLoading(true);
    // try { // Firebase removed
    //   const userCredential = await register(email, password);
    //   if (userCredential && userCredential.user) {
    //     const user = userCredential.user;
    //     // const userDocRef = doc(db, "users", user.uid); // Firebase removed
    //     // await setDoc(userDocRef, { // Firebase removed
    //     //   uid: user.uid,
    //     //   email: user.email,
    //     //   createdAt: serverTimestamp(),
    //     // });
    //     navigate("/DashboardPage"); // Navigate to dashboard after registration
    //   } else {
    //     setError("Échec de la création du compte utilisateur.");
    //   }
    // } catch (err: any) {
    //   setError(err.message || "Échec de l'inscription. Veuillez réessayer.");
    // }
    console.log("Register attempt (Firebase disabled):", { email, password });
    alert("La fonctionnalité d'inscription est temporairement désactivée.");
    setLoading(false);
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-muted/40 py-12">
      <Card className="w-full max-w-md mx-4">
        <CardHeader className="text-center">
          <CardTitle className="text-2xl font-bold">Inscription</CardTitle>
          <CardDescription>
            Créez votre compte FreelanceFlow pour commencer.
          </CardDescription>
        </CardHeader>
        <CardContent>
          <form onSubmit={handleSubmit} className="space-y-6">
            <div className="space-y-2">
              <Label htmlFor="email">Adresse e-mail</Label>
              <Input
                id="email"
                type="email"
                placeholder="exemple@email.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                disabled={loading}
              />
            </div>
            <div className="space-y-2">
              <Label htmlFor="password">Mot de passe</Label>
              <Input
                id="password"
                type="password"
                placeholder="********"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                disabled={loading}
              />
            </div>
            <div className="space-y-2">
              <Label htmlFor="confirm-password">
                Confirmez le mot de passe
              </Label>
              <Input
                id="confirm-password"
                type="password"
                placeholder="********"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                required
                disabled={loading}
              />
            </div>
            {error && (
              <p className="text-sm text-destructive text-center">{error}</p>
            )}
            <Button type="submit" className="w-full" disabled={loading}>
              {loading ? "Création du compte..." : "S'inscrire"}
            </Button>
          </form>
        </CardContent>
        <CardFooter className="flex flex-col items-center space-y-2">
          <p className="text-sm text-muted-foreground">
            Vous avez déjà un compte ?{" "}
            <Link
              to="/login"
              className="font-semibold text-primary hover:underline"
            >
              Connectez-vous
            </Link>
          </p>
        </CardFooter>
      </Card>
    </div>
  );
}
